import React from "react";

import { AmplificationStrategiesDetail } from "../elements/asco-amplification-strategies/detail";
import AmplificationStrategiesBanner from "../elements/asco-amplification-strategies/main-banner";
import ASCOAmplificationStrategiesServicesDetails from "../elements/asco-amplification-strategies/services-slider";
import { ContactSection } from "../elements/contact-section";
import LatestNewsSection from "../elements/latest-news-slider";
import { Conferences } from "../elements/hcp-marketing/conferences";
import HCPConferencesSliderSection from "../elements/hcp-marketing/conferences-slider";
import fulgentLogo from "../../images/logos/fulgent.png";
import labcorpLogo from "../../images/logos/labcorp.png";
import mdHealthLogo from "../../images/logos/md-health.png";
import tempusLogo from "../../images/logos/tempus.png";
import bostonScientific from "../../images/logos/boston-scientific.jpg";
import castleLogo from "../../images/logos/castleLogo.svg";
import acgoConferenceImg from "../../images/largeAudience.png";
const ACG_CLIENTS = [
  {
    client1: {
      logo: bostonScientific,
      alt: "Boston Scientific",
    },
    client2: { logo: castleLogo, alt: "Castle" },
  },
  {
    client1: { logo: fulgentLogo, alt: "Fulgent" },
    client2: {
      logo: labcorpLogo,
      alt: "Labcorp",
    },
  },
  {
    client1: { logo: mdHealthLogo, alt: "MD Health" },
    client2: { logo: tempusLogo, alt: "Tempus AI" },
  },
];

function ACGAmplificationStrategies() {
  return (
    <>
      <AmplificationStrategiesBanner
        title="ACG Amplification Strategies"
        description="Find out how to maximize your ACG conference ROI with our proven digital advertising and video strategies"
        clients={ACG_CLIENTS}
      />
      <AmplificationStrategiesDetail
        description="Maximize your impact at ACG with our comprehensive digital and video solutions designed to engage and educate gastroenterologist HCPs. Utilize pre-conference digital marketing powered by NPI data to reach your target audience well before ACG  begins. During the conference, we offer strategic digital tactics to drive booth traffic, while our on-site video team captures compelling KOL and SME testimonials — whether at your booth or an offsite location. Post - event, we help re-engage HCPs to ensure your message continues to resonate long after ACG concludes."
        imageUrl={acgoConferenceImg}
      />
      <ASCOAmplificationStrategiesServicesDetails isAcg={true} />
      <Conferences />
      <HCPConferencesSliderSection />
      <LatestNewsSection />
      <ContactSection />
    </>
  );
}

export default ACGAmplificationStrategies;
